import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../global/global.service';
const headers = new HttpHeaders()
  .set("Auth-Key", "ba989509ad560f3ee2427ed27fa86a5d")
  .set("Client-Service", "univate-training");
@Injectable({
  providedIn: 'root'
})
export class IndividualService {
  private url = GlobalService.serverURL;
  private courseUrl = GlobalService.serverURL + 'course/';
  // =====================================
  constructor(private http: HttpClient) { }

  detail(data){
    return this.http.post(this.courseUrl + 'details' ,data, { headers });
  }
  dashboard(data){
    return this.http.post(this.url+ 'individual/' + 'dashboard', data,{ headers })
  }
  seeAll(data){
    return this.http.post(this.url+ 'individual/' + 'dashboard/see_all', data,{ headers })
  }
  myCourse(data){
  return  this.http.post(this.url + 'course/purchase_list',data, { headers })
  }
 courseList(data){
    return this.http.post(this.courseUrl + 'listing',data, { headers })
  }
  certificateList(data){
    return this.http.post(this.courseUrl + 'certificate_list',data, { headers })
  }
 purchaseList(data){
    return this.http.post(this.url+ 'individual/' + 'purchase_history',data, { headers })
  }
  subSectionDetail(data){
    return this.http.post(this.courseUrl+  'details/get_sub_section',data, { headers })
  }
  getExam(data){
    return this.http.post(this.courseUrl + 'manage_exam/question_list',data, { headers })
  }
  result(data){
    return this.http.post(this.courseUrl + 'manage_exam/result',data, { headers })
  }
  offerDetail(data){
    return this.http.post(this.url+'individual/dashboard/offer_details',data, { headers })
  }
  affiliateDetail(data){
    return this.http.post(this.url+'individual/dashboard/affiliate_details',data, { headers })
  }
  packageDetail(data){
    return this.http.post(this.url+'individual/dashboard/package_details', data,{ headers })
  }
  viewCourse(data){
    return this.http.post(this.courseUrl+'details/view',data, { headers })
  }
  tracking(data){
    return this.http.post(this.courseUrl + 'tracking/track_subsection', data, { headers })
  }
  getExamList(data){
    // return this.http.get(this.courseUrl + 'manage_exam/listing?course_id=' + course_id + '&purchase_id=' + purchase_id, { headers })
    return this.http.post(this.courseUrl + 'manage_exam/listing',data, { headers })
  }
  manageExamReset(data){
    return this.http.post(this.courseUrl + 'manage_exam/reset_exam',data, { headers })
  }

  getNotification(data) {
    return this.http.post(this.url + 'user/notification/get_notification_company_or_other', data, { headers })
  }
  hideNotification(data) {
    return this.http.post(this.url + 'user/notification/hide_notification', data, { headers })
  }
}
